export const BASE_URL = '/lcm/lcops';
export const VRCC_BASE_URL = '/lcm/vrcc';
export const LOCKER_BASE_URL = '/lcm/locker';
export const REQUEST_BASE_URL = '/lcm/request';
export const GET_ALL_ENVIRONMENT_URL = `${BASE_URL}/api/environments/requests`;

export const GET_ENVIRONMENT_STATE_URL = (requestId: string) =>
  `${BASE_URL}/api/${requestId}/ui`;

export const GET_ENVIRONMENT_ACTIVE_REQUESTS_URL = (environmentId: string) =>
  `${REQUEST_BASE_URL}/api/requests/statusInProgress?requestSource=${environmentId}`;

export const GET_CLOUD_PROXY_ENVIRONMENT_REQUESTS = () =>
  `${BASE_URL}/api/cloudproxyenvironments/requests`;

export const SCALE_OUT_URL = (environmentId: string, productId: string) =>
  `${BASE_URL}/api/environments/${environmentId}/products/${productId}/nodes`;

export const ORGANIC_GROWTH_URL = (environmentId: string) =>
  `${BASE_URL}/api/environments/${environmentId}/addproducts`;

export const ENVIRONMENT_URL = `${BASE_URL}/api/environments`;

export const CREATE_LOCKER_REFERENCES_FROM_JSON_URL = `${BASE_URL}/api/environments/createLockerReferences`;

export const GET_PASSWORD_ALIASES_URL = `${LOCKER_BASE_URL}/api/passwords/list/vmids`;

export const GET_PASSWORD_BY_VMID_URL = (vmid: string) =>
  `${LOCKER_BASE_URL}/api/passwords/detail/${vmid}`;

export const PREVALIDATE_JSON_SPEC_URL = `${BASE_URL}/api/environments/import/prevalidate`;

export const GET_INFRA_METADATA_URL = `${BASE_URL}/api/uimetadata/environment/infra`;

export const GET_NODES_CARDINALITY_URL = (product: string, version: string) =>
  `${BASE_URL}/api/uimetadata/products/${product}/version/${version}/cardinality`;

export const GET_NODE_DEFAULT_PROPERTIES_METADATA_URL = (
  product: string,
  nodeType: string
) => `${BASE_URL}/api/uimetadata/products/${product}/node/${nodeType}/default`;

export const GET_NODE_ADVANCED_PROPERTIES_METADATA_URL = (
  product: string,
  nodeType: string
) => `${BASE_URL}/api/uimetadata/products/${product}/node/${nodeType}/advance`;

export const GET_PRODUCT_METADATA_URL = `${BASE_URL}/api/uimetadata/products/nodes`;

export const GET_PRODUCT_CLUSTER_VIP_METADATA_URL = (
  product: string,
  version: string
) =>
  `${BASE_URL}/api/uimetadata/products/${product}/version/${version}/clustervip`;

export const GET_SCALEOUT_VALIDATION_URL = `${BASE_URL}/api/environments/product/scaleout/validate`;

export const GET_MANUAL_VALIDATIONS_URL = `${BASE_URL}/api/products/manualprecheck`;

export const GET_PRECHECK_VALIDATIONS_URL = (requestId: string) =>
  `${REQUEST_BASE_URL}/api/prevalidationreport?requestId=${requestId}`;

// eslint-disable-next-line max-len
export const RUN_PRECHECK_VALIDATIONS_AND_DEPLOY_WINDOWS_URL = `${BASE_URL}/api/environments/prevalidateandinstallwindows`;

export const RUN_PRECHECK_VALIDATIONS_URL = `${BASE_URL}/api/environments/prevalidate`;

export const GET_CERTIFICATE_ALIASES_URL = `${LOCKER_BASE_URL}/api/certificates/list/vmids`;

export const CONTAINERS_VALIDATE_URL = `${BASE_URL}/api/containers/validate`;

export const CREATE_CONTAINERS_URL = `${BASE_URL}/api/containers?containerType=VRCU`;

export const VALID_CONTAINER_LICENSES_URL = (
  containerId: string,
  destinationName: string
) =>
  `${LOCKER_BASE_URL}/api/license/container/validReplace/${containerId}/${destinationName}`;

export const ADD_REPLACE_CONTAINER_LICENSES_URL = (containerId: string) =>
  `${BASE_URL}/api/containers/${containerId}/replace/licenses`;

export const DELETE_CONTAINER_URL = (containerId: string) =>
  `${BASE_URL}/api/containers/${containerId}`;

export const CONTAINER_INVENTORY_SYNC_URL = (containerId: string) =>
  `${BASE_URL}/api/containers/${containerId}/sync`;

export const UPDATE_CONTAINER_URL = (containerId: string) =>
  `${BASE_URL}/api/containers/${containerId}/properties/password`;

export const DOWNLOAD_ENVIRONMENT_LOGS_URL = (environmentId: string) =>
  `${BASE_URL}/api/environments/${environmentId}/logs`;

export const EXPORT_CONFIGURATION_URL = (environmentId: string, type: string) =>
  `${BASE_URL}/api/environments/${environmentId}/configuration?type=${type}`;

export const NOTIFICATION_URL = (notificationKey: string) =>
  `/lcm/common/api/lcm/common/api/getNotificationByKey/${notificationKey}`;

export const EXPORT_PRODUCT_CONFIGURATION_URL = (
  environmentId: string,
  productId: string,
  type: string
) =>
  `${BASE_URL}/api/environments/${environmentId}/products/${productId}/configuration?type=${type}`;

export const TOGGLE_HEALTH_URL = (environmentId: string, toggle: string) =>
  `${BASE_URL}/api/environments/${environmentId}/healthCheckToggle?toggle=${toggle}`;

export const DOWNLOAD_PRODUCT_LOGS_URL = (
  environmentId: string,
  productId: string,
  tenantId?: string
) => {
  const searchParams = new URLSearchParams();
  if (['vro', 'vssc'].includes(productId) && tenantId) {
    searchParams.append('tenantId', tenantId);
  }
  return `${BASE_URL}/api/environments/${environmentId}/products/${productId}/logs?${searchParams.toString()}`;
};

export const REGISTER_WITH_VRCC = `${VRCC_BASE_URL}/api/v1/register`;
export const VRCC_health = `${VRCC_BASE_URL}/api/v1/health`;
